<template>
    <el-container>
        <el-header class="index-header">
            <div class="container-width">
            <div class="clearfix header-content">
                <div class="fl">
                     <img src="../../assets/image/logo.png">
                </div>
                <div class="fr menu">
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                        <el-menu-item :index="item.sign"  v-for="(item,index) of menu" :key="index">
                             <router-link  :to="item.link">
                               <span v-if="item.sign!=8">{{item.name}}</span> 
                               <img v-if="item.sign==8" src="../../assets/image/shopping.png">
                               <span class="c06" v-if="item.sign==2">(收费)</span>
                              </router-link>
                        </el-menu-item>
                    </el-menu>
                </div>
            </div>
            </div>
        </el-header>
        <el-main class="index-banner" v-if="activeIndex!=6">
            <img src="../../assets/image/banner.jpg">
        </el-main>
        <el-main class="index-main" >
            <div class="container-width" v-if="activeIndex!=6">
                <div class="main">
                   <router-view></router-view>
                </div>
            </div>
            <div v-if="activeIndex==6">
                 <router-view></router-view>
            </div>
        </el-main>
        <el-footer class="index-footer" style="height:auto">
            <footers></footers>
        </el-footer>
    </el-container>
</template>

<script>
import footers from "../../components/footer";
export default {
  components: {
    footers
  },
  data() {
    return {
      activeIndex: "1",
      menu: [
        {
          sign: "1",
          link: "/",
          name: "首页"
        },
        {
          sign: "2",
          link: "/healthCare/caseList",
          name: "医疗方案"
        }, 
         {
          sign: "7",
          link: "/drug/drugList",
          name: "药品信息"
        }, 
        {
          sign: "3",
          link: "/service/service",
          name: "专业服务"
        },
         {
          sign: "4",
          link: "/charge/charge",
          name: "收费标准"
        },
         {
          sign: "5",
          link: "/about/about",
          name: "关于我们"
        },
        {
          sign: "6",
          link: "/userCenter/template",
          name: "用户中心"
        },
         {
          sign: "8",
          link: "/shopping/cart",
          name: "购物车"
        }
      ]
    };
  },
  watch: {
    $route(to, from) {
      this.menuSave();
    }
  },
  mounted() {
    this.menuSave();
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    menuSave() {
       this.activeIndex=this.$route.meta.sign;
    }
  }
};
</script>

<style lang="scss">
// 头部
.index-header {
  height: 110px !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  .header-content {
    display: table-cell;
    vertical-align: middle;
    height: 110px;
    width: 1000px;
    .menu {
      display: inline-block;
      li {
        height: 40px;
      }
      .el-menu--horizontal > .el-menu-item {
        line-height: 40px;
      }
      .el-menu.el-menu--horizontal {
        border-bottom: 0;
      }
      .el-menu--horizontal > .el-menu-item.is-active {
        color: #06c88c;
      }
      .el-menu-item{
          padding: 0;
          width: 110px;text-align: center;
          a{
              display: block;
          }
      }
    }
  }
}
// banner
.index-banner {
  padding: 2px 0 0 0px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.09);
  img {
    width: 100%;
    display:block
  }
}
// 内容
.index-main {
    padding: 0;
  .main {
    padding: 60px 0;
  }
 
}
// 底部
.index-footer {
  padding: 0;
}
</style>
